export default __webpack_public_path__ + "images/842a575001fb000b3614ebc2085b6935.webp";